import {useTranslation} from 'react-i18next';
import {User} from '../../../../../context/BookingContext';
import {BigToggle} from '../../../../form/toggle/BigToggle';
import {PeopleSkeleton} from '../../../../layout/skeleton/people-skeleton/PeopleSkeleton';

interface AuthenticatedPeopleListProps {
    loading: boolean;
    user: User | null;
    selfBookingOnly: boolean;
    selectedPersonsIds: Array<string>;
    selectPerson(identity: string): void;
    validateUser?(user: User): boolean;
    ageRange?: [minAge: number | null, maxAge: number | null];
}

export function AuthenticatedPeopleList({
    loading,
    user,
    selfBookingOnly,
    selectedPersonsIds,
    selectPerson,
    validateUser,
    ageRange = [null, null]
}: AuthenticatedPeopleListProps) {
    const {t} = useTranslation();
    const [minAge, maxAge] = ageRange;

    const ageError = (age: number): string => {
        const errorMin = minAge ? minAge > age : false;
        const errorMax = maxAge ? maxAge < age : false;
        let errorMsg = '';

        if (errorMin && errorMax) {
            errorMsg = t('arrival.identity_age_range_error', {minAge, maxAge});
        } else if (errorMin) {
            errorMsg = t('arrival.identity_age_over_error', {minAge});
        } else if (errorMax) {
            errorMsg = t('arrival.identity_age_under_error', {maxAge});
        }

        return errorMsg;
    };

    return (
        <>
            {loading && <PeopleSkeleton />}
            {!loading && user !== null && (
                <div className='people__list-section__list'>
                    <BigToggle
                        label={user.givenName + ' ' + user.familyName}
                        sublabel={user.identity}
                        checked={selectedPersonsIds.includes(user.identity)}
                        onClick={() => selectPerson(user.identity)}
                        id={user.identity}
                        key={user.identity}
                        disabled={validateUser ? validateUser(user) : false}
                    />
                    <p className='input-error'>{ageError(user.age ?? 0)}</p>

                    {user.relations &&
                        !selfBookingOnly &&
                        user.relations.map((r) => {
                            return (
                                r.relationType === 'child' && (
                                    <>
                                        <BigToggle
                                            label={r.givenName + ' ' + r.familyName}
                                            sublabel={r.identity}
                                            checked={selectedPersonsIds.includes(r.identity)}
                                            onClick={() => selectPerson(r.identity)}
                                            id={r.identity}
                                            key={r.identity}
                                            disabled={validateUser ? validateUser(r) : false}
                                        />
                                        <p className='input-error'>{ageError(r.age ?? 0)}</p>
                                    </>
                                )
                            );
                        })}
                </div>
            )}
        </>
    );
}
